<template>
  <div class="assets-date-picker flex-column w-100 pt-3">
    <div class="date-picker">
      <label>{{ $t("from") }}</label>
      <date-picker v-model="from" locale="sk" />
    </div>

    <div class="date-picker">
      <label>{{ $t("to") }}</label>
      <date-picker v-model="to" locale="sk" />
    </div>

    <button type="button" class="btn btn-warning m-3" @click="onOkClicked()">
      <span class="ml-2 mr-2">{{ $t("OK") }}</span>
    </button>
  </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
  name: "AssetsDatePicker",
  components: {
    DatePicker
  },
  props: {
    onSelect: {
      required: true
    },
    fromDate: {
      required: false
    },
    toDate: {
      required: false
    },
  },
  methods: {
    onOkClicked() {
      if (this.onSelect) {
        this.onSelect(this.from, this.to);
      }
    }
  },
  data() {
    return {
      from: this.fromDate,
      to: this.toDate
    };
  }
};
</script>

<style lang="scss">
.assets-date-picker {
  display: flex;
  position: absolute;
  right: 0;
  z-index: 2;
  background: #5f5f5f;
  margin: 6px 0 0 0;

  .date-picker {
    margin: 5px 15px 15px 15px;

    input {
      border-radius: unset;
    }
  }

  button {
    margin-top: 35px;
    margin-right: 15px;
    height: 40px;
  }
}
</style>
